// External Imports
import { BodyText, Modal, Stack } from '@lessonnine/design-system.lib';
import React from 'react';
import { t } from 'src/viewLayer/helpers/translations.js';

import {
  ModalContainer,
  ModalTitle,
} from './index.styled.js';

// Component Definition
function SuccessModal({ email, handleCloseModal, isOpen }) {
  return (
    <ModalContainer ariaLabel="SuccessModal" isOpen={isOpen} onClose={handleCloseModal}>
      <Modal.Header />
      <Modal.Body>
        <Stack align="center" gap={{
          small: 20,
          xxsmall: 12,
        }}
        padding={[24, 0, 44]}>
          <ModalTitle size={{
            small: 'default',
            xxsmall: 'small',
          }} textAlign="center" weight="strong">
            {t('login.magic_link.email_confirmation_header')}
          </ModalTitle>
          <BodyText size={{
            small: 'large',
            xxsmall: 'default',
          }} textAlign="center" >
            {t('login.magic_link.email_confirmation_body')}
            <BodyText as="span" weight="strong">{email}</BodyText>.
          </BodyText>
        </Stack>
      </Modal.Body>
    </ModalContainer>
  );
}

export { SuccessModal };
